/*
 * ARTICLE TOC — sommaire d'article de blog
 * Scanne les H2 du contenu de l'article, leur ajoute une ancre et construit
 * la liste de liens. L'élément se masque s'il n'y a aucun H2.
 * Le décalage sous le header sticky est géré par le scroll-padding-top global.
 */
class ArticleToc extends HTMLElement {
	connectedCallback() {
		const content = document.querySelector(this.getAttribute('content-selector') || '.article-main .prose');
		const list = this.querySelector('.article-toc__list');

		if (!content || !list) {
			this.hidden = true;
			return;
		}

		const headings = [...content.querySelectorAll('h2')].filter((h) => h.textContent.trim() !== '');

		if (headings.length === 0) {
			this.hidden = true;
			return;
		}

		const usedIds = new Set();

		headings.forEach((heading) => {
			if (!heading.id) {
				let slug = this.slugify(heading.textContent) || 'section';
				let unique = slug;
				let i = 2;

				while (usedIds.has(unique) || document.getElementById(unique)) {
					unique = `${slug}-${i++}`;
				}

				heading.id = unique;
			}

			usedIds.add(heading.id);

			const item = document.createElement('li');
			const link = document.createElement('a');
			link.className = 'article-toc__link';
			link.href = `#${heading.id}`;
			link.textContent = heading.textContent.trim();
			item.appendChild(link);
			list.appendChild(item);
		});

		this.setupScrollSpy(headings);
	}

	slugify(text) {
		return text
			.trim()
			.toLowerCase()
			.normalize('NFD')
			.replace(/[̀-ͯ]/g, '')
			.replace(/[^a-z0-9\s-]/g, '')
			.replace(/[\s-]+/g, '-')
			.replace(/^-+|-+$/g, '')
			.slice(0, 80);
	}

	setupScrollSpy(headings) {
		const setActive = (id) => {
			this.querySelectorAll('.article-toc__link').forEach((link) => {
				link.classList.toggle('is-active', link.getAttribute('href') === `#${id}`);
			});
		};

		// La section "courante" est celle du dernier H2 passé au-dessus du tiers haut du viewport
		// (listener scroll passif throttlé en rAF : fiable aussi après un saut d'ancre)
		let ticking = false;

		const update = () => {
			ticking = false;
			const threshold = window.innerHeight * 0.35;
			const fromTop = headings.filter((h) => h.getBoundingClientRect().top < threshold);
			setActive(fromTop.length > 0 ? fromTop[fromTop.length - 1].id : null);
		};

		window.addEventListener(
			'scroll',
			() => {
				if (!ticking) {
					ticking = true;
					requestAnimationFrame(update);
				}
			},
			{ passive: true }
		);

		update();
	}
}

if (!customElements.get('article-toc')) {
	customElements.define('article-toc', ArticleToc);
}
